// extracted by mini-css-extract-plugin
export default {"additionalTools":"AdditionalToolIcon_additionalTools__UbgOf"};